import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { makeStyles } from '@material-ui/core/styles'
import QuoteTable from 'components/quote/Table'
import QuoteSummary from 'components/quote/Summary'

import selectors from 'store/selectors'
import quoteActions from 'store/modules/quote'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(5),
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  table: {
    paddingBottom: theme.spacing(3),
  }
}))

const QuoteTasksExport = ({

}) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const quote = useSelector(selectors.quote.collection.item)
  const client = useSelector(selectors.quote.quoteClient)
  const project = useSelector(selectors.project.activeProject)
  const folderid = 'root'
  const tree = useSelector(selectors.quote.tree)
  const rows = useSelector(selectors.quote.rows)
  const markups = useSelector(selectors.quote.markups)
  const totals = useSelector(selectors.quote.totals)
  const inputVat = useSelector(selectors.quote.inputVatField)
  const inputMarkups = useSelector(selectors.quote.inputMarkupFields)
  const edits = useSelector(selectors.quote.edits)
  const inputs = useSelector(selectors.quote.inputs)
  const currency = useSelector(selectors.project.currency)
  const expanded = useSelector(selectors.quote.expanded)
  const editName = useSelector(selectors.quote.editName)
  const sortMode = useSelector(selectors.quote.sortMode)
  const materialRows = useSelector(selectors.quote.mergedMaterials)

  return (
    <div className={ classes.root }>
      <div className={ classes.summary }>
        <QuoteSummary
          title="Material Take Off Sheet"
          quote={ quote }
          client={ client }
          project={ project }
        />
      </div>
      <div className={ classes.table }>
        <QuoteTable
          clientView
          readOnly
          noTotals
          quote={ quote }
          tree={ tree }
          folderid={ folderid }
          rows={ materialRows }
          markups={ markups }
          totals={ totals }
          inputVat={ inputVat }
          inputMarkups={ inputMarkups }
          currency={ currency }
          edits={ edits }
          inputs={ inputs }
          expanded={ expanded }
          sortMode={ false }
          editName={ editName }
        />
      </div>
    </div>
  )
}

export default QuoteTasksExport